export function DeleteEventNativeBackButton(): MethodDecorator {
  return (target: Object, key: string, descriptor: PropertyDescriptor) => {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]): any {
      if (history.state !== null) {
        history.pushState(null, null, window.location.href);
      }
      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
